<template>
  <el-table :data="items" size="small" class="mt-10" v-loading="loading">
    <el-table-column label="成品编号/数量" prop="product.code">
      <template slot-scope="scope">
        {{ scope.row.product.code }}
        {{
          scope.row.product.code_type == 2
            ? `（x${scope.row.product.number}）`
            : ''
        }}
      </template>
    </el-table-column>
    <el-table-column label="成品分类" prop="product.name"></el-table-column>
    <el-table-column label="来源" prop="receive_from">
      <template slot-scope="scope">
        <span>{{ scope.row.receive_from || '-' }}</span>
      </template>
    </el-table-column>
    <el-table-column label="接收日期" prop="receive_date">
      <template slot-scope="scope">
        <span v-if="scope.row.code_type == 2 && scope.row.send_date">-</span>
        <span v-else>{{ scope.row.receive_date }}</span>
      </template>
    </el-table-column>
    <el-table-column label="返回日期" prop="send_date">
      <template slot-scope="scope">
        <span v-if="scope.row.code_type == 2 && scope.row.receive_date">-</span>
        <span v-else>{{ scope.row.send_date || '未返回' }}</span>
      </template>
    </el-table-column>
    <el-table-column label="去往" prop="send_to">
      <template slot-scope="scope">
        <span>{{ scope.row.send_to || '-' }}</span>
      </template>
    </el-table-column>
    <el-table-column label="返回状态">
      <template slot-scope="scope">
        <ItemStatus
          :status="scope.row.status"
          model="productWellPeriod"
        ></ItemStatus>
      </template>
    </el-table-column>
    <!-- <el-table-column label="使用时长" prop="total_hour"></el-table-column> -->
  </el-table>
</template>

<script>
export default {
  props: {
    items: null,
    loading: false,
  },
}
</script>